export { default } from './getFallbackImage'
